import { Component, Input } from '@angular/core';
import { FileUploadFileType } from '../../../../core/interfaces/file-upload-interfaces';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-file-type-text',
  standalone: true,
  imports: [TranslocoPipe],
  templateUrl: './file-type-text.component.html',
  styleUrl: './file-type-text.component.css'
})
export class FileTypeTextComponent {
  @Input() fileType?: FileUploadFileType | null;
  FileType = FileUploadFileType;
}
